<script lang="ts">
  export let color: "yellow" | "gray" | "black";
  export let filler = false;
  export let nopadding = false;
  export let isSticky = false;

  $: backgroundColor =
    color === "yellow"
      ? "var(--row-background-yellow)"
      : color === "gray"
        ? "var(--row-background-gray)"
        : color;
</script>

<div
  class:filler
  class:nopadding
  class:sticky={isSticky}
  class="container"
  style="--background-color: {backgroundColor}"
>
  <aside />
  <section class:dark={color === "gray" || color === "black"}>
    <slot />
  </section>
  <aside />
</div>

<style>
  .container {
    display: flex;
    background: var(--background-color);
  }
  aside {
    flex-grow: 1;
    width: 0;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.15);
    pointer-events: none;
  }

  section {
    color: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100vw;
    width: var(--content-width);
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 1rem;
    padding-bottom: 3rem;
    padding-top: 1rem;
  }

  section.dark {
    color: #fff;
  }

  .filler {
    flex-grow: 1;
    height: 0;
    overflow: hidden;
    padding: 0;
  }

  .nopadding section {
    padding: 0;
  }

  .container.sticky {
    position: sticky;
    top: var(--navbar-height);
    z-index: 10;
  }
</style>
